import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { knoxApi } from '@/lib/knox-api';

/** Handles OAuth callback — reads session from cookie and redirects */
export function LoginCallbackPage() {
  const { user, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check URL for error params
    const params = new URLSearchParams(window.location.search);
    const errParam = params.get('error');
    if (errParam) {
      setError(errParam);
      return;
    }

    if (!loading && user) {
      const workspaceId = user.default_workspace_id;

      if (workspaceId) {
        navigate(`/workspaces/${workspaceId}`, { replace: true });
        return;
      }

      // No org — try auto-join if pending join token exists
      const joinToken = localStorage.getItem('pending_join_token');
      if (joinToken) {
        localStorage.removeItem('pending_join_token');
        localStorage.removeItem('pending_invite_token');
        knoxApi.joinOrgLoggedIn({ token: joinToken })
          .then(() => { window.location.href = '/workspaces'; })
          .catch(() => navigate('/org-binding', { replace: true }));
        return;
      }

      // No join token — check invite token
      const inviteToken = localStorage.getItem('pending_invite_token');
      localStorage.removeItem('pending_invite_token');
      if (inviteToken) {
        navigate(`/invite`, { state: { token: inviteToken }, replace: true });
        return;
      }

      navigate('/org-binding', { replace: true });
    }
  }, [user, loading, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center">
          <p className="text-destructive">Login failed: {error}</p>
          <a href="/login" className="mt-4 text-primary hover:underline">
            Try again
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <p className="text-muted-foreground">Completing login...</p>
    </div>
  );
}
